<template>
  <div>
    <ul>
      <template v-if="condition.parameter.userId">
        <li
          v-if="getConditionOrUndefined('userId')"
          style="display:inline-block"
          data-test="search-user-id"
        >
          会員ID：{{ condition.parameter.userId }}を選択
        </li>
      </template>
      <template v-else>
        <li
          v-if="getConditionOrUndefined('age.minimum')"
          style="display:inline-block"
          data-test="search-lower-age"
        >
          年齢下限：{{ condition.parameter.age.minimum }}歳
        </li>
        <li
          v-if="getConditionOrUndefined('age.maximum')"
          style="display:inline-block"
          data-test="search-upper-age"
        >
          年齢上限：{{ condition.parameter.age.maximum }}歳
        </li>
        <li
          v-if="getConditionOrUndefined('gender')"
          style="display:inline-block"
          data-test="search-gender"
        >
          性別：{{ convertLabel(condition.parameter.gender,'genders') }}
        </li>
        <li
          v-if="(prefecturesWithCities && getConditionOrUndefined('address.selectedOption') === '')"
          style="display:inline-block"
          data-test="search-prefectures"
        >
          {{ convertNonAnswerUser('現住所・希望勤務地','address.containNonHopeUser') }}：[{{ prefecturesWithCities }}]
        </li>
        <li
          v-else-if="(prefecturesWithCities && getConditionOrUndefined('address.selectedOption') === 'present_address')"
          style="display:inline-block"
          data-test="search-prefectures"
        >
          現住所：[{{ prefecturesWithCities }}]
        </li>
        <li
          v-else-if="(prefecturesWithCities && getConditionOrUndefined('address.selectedOption') === 'desired_work_place')"
          style="display:inline-block"
          data-test="search-prefectures"
        >
          {{ convertNonAnswerUser('希望勤務地','address.containNonHopeUser') }}：[{{ prefecturesWithCities }}]
        </li>
        <li
          v-if="getConditionOrUndefined('educationalBackground')"
          style="display:inline-block"
          data-test="search-educational-background"
        >
          最終学歴：{{ convertLabel(condition.parameter.educationalBackground,'educationalBackgrounds') }}
        </li>
        <li
          v-if="graduationYear"
          style="display:inline-block"
          data-test="search-graduated-school-year"
        >
          卒業年：{{ graduationYear }}
        </li>
        <li
          v-if="getConditionOrUndefined('graduatedSchool.deptCodes') && getConditionOrUndefined('graduatedSchool.deptCodes').length"
          style="display:inline-block"
          data-test="search-graduated-school-dept"
        >
          学部学科コード：[{{ condition.parameter.graduatedSchool.deptCodes.map(deptCode=>convertLabel(deptCode,'educationalDepartments')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('graduatedSchool.keywords') && getConditionOrUndefined('graduatedSchool.keywords').length"
          style="display:inline-block"
          data-test="search-graduated-school"
        >
          学校名/学部/学科/専攻：[{{ condition.parameter.graduatedSchool.keywords.join('、') }}] {{ condition.parameter.graduatedSchool.operator | parseOperator }}
        </li>
        <li
          v-if="changeOverJobsCountLabel"
          style="display:inline-block"
          data-test="search-changeover-jobs-count"
        >
          転職回数：{{ changeOverJobsCountLabel }}
        </li>
        <li
          v-if="getConditionOrUndefined('employed') || getConditionOrUndefined('employed') === 0"
          style="display:inline-block"
          data-test="search-employed"
        >
          就業状況：{{ condition.parameter.employed | convertEmployedLabel }}
        </li>
        <li
          v-if="getConditionOrUndefined('annualSalary.minimum')"
          style="display:inline-block"
          data-test="search-lower-annual-salary"
        >
          直近の年収下限：{{ condition.parameter.annualSalary.minimum }}万円
        </li>
        <li
          v-if="getConditionOrUndefined('annualSalary.maximum')"
          style="display:inline-block"
          data-test="search-upper-annual-salary"
        >
          直近の年収上限：{{ condition.parameter.annualSalary.maximum }}万円
        </li>
        <li
          v-if="occupationOperatorLabel(getConditionOrUndefined('occupations.operator'))"
          style="display:inline-block"
          data-test="occupations-operator"
        >
          {{ occupationOperatorLabel(getConditionOrUndefined('occupations.operator')) }}
        </li>
        <li
          v-if="getConditionOrUndefined('occupations.experienced') && getConditionOrUndefined('occupations.experienced').length"
          style="display:inline-block"
          data-test="search-occupations"
        >
          経験職種：[{{ condition.parameter.occupations.experienced.map(id => convertLabelForLv2(id, 'occupations')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('occupations.desired') && getConditionOrUndefined('occupations.desired').length"
          style="display:inline-block"
          data-test="search-occupations"
        >
          {{ convertNonHopeUser('希望職種','occupations.containNonHopeUser') }}：[{{ condition.parameter.occupations.desired.map(id => convertLabelForLv2(id, 'occupations')).join('、') }}]
        </li>
        <li
          v-if="businessOperatorLabel(getConditionOrUndefined('businesses.operator'))"
          style="display:inline-block"
          data-test="business-operator"
        >
          {{ businessOperatorLabel(getConditionOrUndefined('businesses.operator')) }}
        </li>
        <li
          v-if="getConditionOrUndefined('businesses.experienced') && getConditionOrUndefined('businesses.experienced').length"
          style="display:inline-block"
          data-test="search-businesses"
        >
          経験業種：[{{ condition.parameter.businesses.experienced.map(id => convertLabel(id, 'businesses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('businesses.desired') && getConditionOrUndefined('businesses.desired').length"
          style="display:inline-block"
          data-test="search-businesses"
        >
          {{ convertNonHopeUser('希望業種','businesses.containNonHopeUser') }}：[{{ condition.parameter.businesses.desired.map(id => convertLabel(id, 'businesses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('skills.conditions') && getConditionOrUndefined('skills.conditions').length"
          style="display:inline-block"
          data-test="search-skills"
        >
          スキル：[{{ skillsConditionLabel }}] {{ condition.parameter.skills.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('licenses.ids') && getConditionOrUndefined('licenses.ids').length"
          style="display:inline-block"
          data-test="search-licenses"
        >
          資格：[{{ condition.parameter.licenses.ids.map(id => licensesLabelById(id)).join('、') }}] {{ condition.parameter.licenses.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('isReviewSaved')"
          style="display:inline-block"
          data-test="search-is-review-saved"
        >
          行動ターゲティング：この求人を気になるリストに保存している会員
        </li>
        <li
          v-if="getConditionOrUndefined('activeRecent') || getConditionOrUndefined('activeRecent') === 0"
          style="display:inline-block"
          data-test="search-active-recent"
        >
          最終ログイン：{{ condition.parameter.activeRecent }}日以内
        </li>
        <li
          v-if="getConditionOrUndefined('hasCareerResumes')"
          style="display:inline-block"
          data-test="search-has-career-resumes"
        >
          「職務経歴」登録済みのみ
        </li>
        <li
          v-if="getConditionOrUndefined('toeicScore.minimum')"
          style="display:inline-block"
          data-test="search-toeic-score"
        >
          TOEIC：{{ condition.parameter.toeicScore.minimum }}点以上
        </li>
        <li
          v-if="getConditionOrUndefined('toeflScore.minimum')"
          style="display:inline-block"
          data-test="search-toefl-score"
        >
          TOEFL：{{ condition.parameter.toeflScore.minimum }}点以上
        </li>
        <li
          v-if="getConditionOrUndefined('languageSkills') && getConditionOrUndefined('languageSkills').length
            && condition.parameter.languageSkills.find(languageSkill => languageSkill.id === englishId)"
          style="display:inline-block"
          data-test="search-english-skill"
        >
          英語スキル：{{ convertLabel(condition.parameter.languageSkills.find(languageSkill => languageSkill.id === englishId).level, 'languageSkills') }}
        </li>
        <li
          v-if="getConditionOrUndefined('languageSkills') && getConditionOrUndefined('languageSkills').length
            && condition.parameter.languageSkills.find(languageSkill => languageSkill.id !== englishId)"
          style="display:inline-block"
          data-test="search-language-skill"
        >
          英語以外の語学スキル：[{{ condition.parameter.languageSkills.filter(languageSkill => languageSkill.id !== englishId).map(language=>`${convertLabel(language.id, 'languages')}(${convertLabel(language.level, 'languageSkills')})`).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('freeWord.keywords') && getConditionOrUndefined('freeWord.keywords').length"
          style="display:inline-block"
          data-test="search-free-word"
        >
          フリーワード：[{{ condition.parameter.freeWord.keywords.join('、') }}] {{ condition.parameter.freeWord.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('excludeWord.keywords') && getConditionOrUndefined('excludeWord.keywords').length"
          style="display:inline-block"
          data-test="search-exclude-word"
        >
          除外ワード：[{{ condition.parameter.excludeWord.keywords.join('、') }}] {{ condition.parameter.excludeWord.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('employmentTypes') && getConditionOrUndefined('employmentTypes').length"
          style="display:inline-block"
          data-test="search-employment-types"
        >
          直近の雇用形態：[{{ condition.parameter.employmentTypes.map(employmentType=>convertLabel(employmentType,'employmentStatuses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('desiredEmploymentTypes') && getConditionOrUndefined('desiredEmploymentTypes').length"
          style="display:inline-block"
          data-test="search-desired-employment-types"
        >
          希望の雇用形態：[{{ condition.parameter.desiredEmploymentTypes.map(employmentType=>convertLabel(employmentType,'employmentStatuses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('excludedApproachedScout.otherCompany.maximum')"
          style="display:inline-block"
          data-test="approached-other-company"
        >
          他社からのスカウト受け取り数：{{ condition.parameter.excludedApproachedScout.otherCompany.maximum }}社以内
        </li>
        <li
          v-if="getConditionOrUndefined('married') !== undefined && getConditionOrUndefined('married') !== null"
          style="display:inline-block"
          data-test="married"
        >
          未既婚：{{ condition.parameter.married ? '既婚' : '未婚' }}
        </li>
        <li
          v-if="getConditionOrUndefined('hasChild') !== undefined && getConditionOrUndefined('hasChild') !== null"
          style="display:inline-block"
          data-test="has-child"
        >
          子供有無：{{ condition.parameter.hasChild ? '子供あり' : '子供なし' }}
        </li>
        <li
          v-if="getConditionOrUndefined('canHomeMoving') !== undefined && getConditionOrUndefined('canHomeMoving') !== null"
          style="display:inline-block"
          data-test="can-home-moving"
        >
          転居を伴う転職：{{ condition.parameter.canHomeMoving ? '可能' : '不可' }}
        </li>
        <li
          v-if="getConditionOrUndefined('workStyles.conditions') && getConditionOrUndefined('workStyles.conditions').length"
          style="display:inline-block"
          data-test="search-work-style"
        >
          志向の指定：[{{ condition.parameter.workStyles.conditions.map(condition => convertLabel(condition.id,'workStyles')).join('、') }}] {{ condition.parameter.workStyles.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefinedCondition('selectedRegistrationDateValue.name')"
          style="display:inline-block"
          data-test="search-registration-date"
        >
          登録時期：{{ condition.condition.selectedRegistrationDateValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('registrationDate.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('registrationDate.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="search-registration-date-from"
          >
            登録時期From：{{ condition.parameter.registrationDate.selectedDateTimeRangeForm.from }}
          </li>
          <li
            v-if="getConditionOrUndefined('registrationDate.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="search-registration-date-to"
          >
            登録時期To：{{ condition.parameter.registrationDate.selectedDateTimeRangeForm.to }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefinedCondition('selectedResumeUpdateDateValue.name')"
          style="display:inline-block"
          data-test="search-resume-update-date"
        >
          レジュメ更新日：{{ condition.condition.selectedResumeUpdateDateValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="search-resume-update-date-from"
          >
            レジュメ更新日From：{{ condition.parameter.resumeUpdateDate.selectedDateTimeRangeForm.from }}
          </li>
          <li
            v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="search-resume-update-date-to"
          >
            レジュメ更新日To：{{ condition.parameter.resumeUpdateDate.selectedDateTimeRangeForm.to }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefined('activeDate.from')"
          style="display:inline-block"
          data-test="search-active-date-from"
        >
          最終ログイン時期From：{{ condition.parameter.activeDate.from }}
        </li>
        <li
          v-if="getConditionOrUndefined('activeDate.to')"
          style="display:inline-block"
          data-test="search-active-date-to"
        >
          最終ログイン時期To：{{ condition.parameter.activeDate.to }}
        </li>
        <li
          v-if="getConditionOrUndefinedCondition('selectedApproachedThisJobOptionValue.name')"
          style="display:inline-block"
          data-test="approached-this-job"
        >
          この自社求人のスカウト時期で除外：{{ condition.condition.selectedApproachedThisJobOptionValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="approached-this-job-from"
          >
            From：{{ condition.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from | parseDate }}
          </li>
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="approached-this-job-to"
          >
            To：{{ condition.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to | parseDate }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefinedCondition('selectedApproachedOtherJobOptionValue.name')"
          style="display:inline-block"
          data-test="approached-other-job"
        >
          その他の自社求人のスカウト時期で除外：{{ condition.condition.selectedApproachedOtherJobOptionValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="approached-other-job-from"
          >
            From：{{ condition.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from | parseDate }}
          </li>
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="approached-other-job-to"
          >
            To：{{ condition.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to | parseDate }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefined('excludedCandidateOtherJob')"
          style="display:inline-block"
          data-test="excluded-candidate-other-company-job"
        >
          送信候補：その他の自社求人で送信候補に入れている会員を除外
        </li>
        <li
          v-if="getConditionOrUndefined('excludeEntryOtherCompanyJob')"
          style="display:inline-block"
          data-test="exclude-entry-other-company-job"
        >
          他社求人への応募：他社の求人へ応募済みの会員を除外
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import * as definition from '@/lib/labelValueMappings'
import { parseHierarchicalObjects } from '@/lib/parse'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import dayjs from 'dayjs'

export default {
  name: 'SearchResultCondition',
  filters: {
    convertEmployedLabel (id) {
      return id || id === 0 ? definition.employed[id].name : ''
    },
    parseOperator (operator) {
      return operator === 'and' ? 'すべてを含む' : 'いずれかを含む'
    },
    parseDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    }
  },
  props: {
    jobId: {
      type: Number,
      required: true
    }
  },
  computed: {
    englishId: () => '10',
    ...mapGetters({
      conditionByJobId: 'membersSearchCondition',
      skillsMaster: 'skillsMaster',
      prefecturesMaster: 'prefecturesMaster'
    }),
    skillsConditionLabel () {
      if (!this.condition.parameter.skills || !this.condition.parameter.skills.conditions) return ''

      const experiences = this.getSkillExperiences(0)
      return Object.keys(experiences).map(key => {
        const experienceValues = experiences[key]
        experienceValues.map(val => {
          val.year = this.condition.parameter.skills.conditions.find(skill => skill.id === val.id).years.minimum
        })

        const subCategories = _.groupBy(experienceValues, val => {
          return val.path[1].name
        })

        return `${key}：` + Object.keys(subCategories).map(key => {
          return `[${key}]${subCategories[key].map(i => i.name + '（' + definition.searchSkillExperienceRange.find(item => item.id === i.year + '').name + '）').join('、')}`
        }).join('、')
      }).join('、')
    },
    condition () {
      return this.conditionByJobId(this.jobId)
    },
    prefecturesWithCities () {
      const prefectures = _.get(this.condition, 'parameter.address.prefectures', [])
      const cities = _.get(this.condition, 'parameter.address.cities', [])

      // 都道府県も市区町村も指定されていない場合には空文字を返却
      if (prefectures.length === 0 && cities.length === 0) return ''

      // 市区町村を都道府県別にグルーピング
      const citiesMap = _.groupBy(
        _.filter(parseHierarchicalObjects(this.prefecturesMaster), master => {
          return cities.some(cityId => cityId === master.id)
        }),
        o => o.path[1].id // 都道府県ID
      )
      return this.prefecturesMaster
        .flatMap(area => area.children.map(masterPrefecture => masterPrefecture.id)) // 都道府県マスタIDの一覧
        .reduce((prefectureList, masterPrefectureId) => {
          // 先に市区町村から判定（都道府県と市区町村が重複して登録されていた場合を考慮）
          if (Object.keys(citiesMap).some(citiesPrefectureId => citiesPrefectureId === masterPrefectureId)) {
            const citiesText = citiesMap[masterPrefectureId].map(city => city.name).join('、')
            return [...prefectureList, `${citiesMap[masterPrefectureId][0].path[1].name}(${citiesText})`]
          }
          // 都道府県のみ指定の判定
          if (prefectures.some(prefectureId => prefectureId === masterPrefectureId)) {
            return [...prefectureList, this.$store.getters.convertLabelForLv2ById(masterPrefectureId, 'prefectures')]
          }
          // それ以外は加算せずに返却
          return prefectureList
        }, [])
        .join('、')
    },
    changeOverJobsCountLabel () {
      const jobsCount = this.getConditionOrUndefined('changeOverJobsCount.maximum')
      if (jobsCount == null) return false
      return definition.changeOverJobsCount[jobsCount].name
    },
    graduationYear () {
      const from = this.getConditionOrUndefined('graduatedSchool.year.from')
      const to = this.getConditionOrUndefined('graduatedSchool.year.to')
      if (from && to) {
        return `${from}年〜${to}年`
      } else if (from) {
        return `${from}年〜`
      } else if (to) {
        return `〜${to}年`
      } else {
        return ''
      }
    }
  },
  methods: {
    convertLabel (id, mastersKey) {
      return this.$store.getters.convertLabelById(id, mastersKey)
    },
    convertLabelForLv2 (id, mastersKey) {
      return this.$store.getters.convertLabelForLv2ById(id, mastersKey)
    },
    convertNonHopeUser (label, path) {
      if (this.getConditionOrUndefined(path)) {
        label = label + '(どちらでもない・未入力の会員を含む)'
      }
      return label
    },
    convertNonAnswerUser (label, path) {
      if (this.getConditionOrUndefined(path)) {
        label = label + '(未入力の会員を含む)'
      }
      return label
    },
    occupationOperatorLabel (key) {
      const experiencedOccupations = this.getConditionOrUndefined('occupations.experienced') || []
      const desiredOccupations = this.getConditionOrUndefined('occupations.desired') || []
      return experiencedOccupations.length || desiredOccupations.length ? _.find(definition.occupationOperators, { key: key }).label : ''
    },
    businessOperatorLabel (key) {
      const experiencedBusinesses = this.getConditionOrUndefined('businesses.experienced') || []
      const desiredBusinesses = this.getConditionOrUndefined('businesses.desired') || []
      return experiencedBusinesses.length || desiredBusinesses.length ? _.find(definition.businessOperators, { key: key }).label : ''
    },
    getConditionOrUndefined (path) {
      return _.get(this.condition.parameter, path)
    },
    getConditionOrUndefinedCondition (path) {
      return _.get(this.condition.condition, path)
    },
    licensesLabelById (id) {
      return this.convertLabelForLv2(id, 'licenses')
    },
    getSkillExperiences (groupLayer) {
      return _.groupBy(
        _.filter(parseHierarchicalObjects(this.skillsMaster), master => {
          return this.condition.parameter.skills.conditions.some(skill => skill.id === master.id)
        }),
        o => o.path[groupLayer].name
      )
    }
  }
}
</script>
